import { o as otto } from "../chunks/common-nexus-client-CdICzBNm.mjs";
const PREFIX = "tr-v1";
const tracking = otto[PREFIX] ?? {};
const onInit = tracking.onInit;
const lockInit = tracking.lockInit;
const unlockInit = tracking.unlockInit;
export {
  PREFIX,
  lockInit,
  onInit,
  tracking,
  unlockInit
};
/*                                        */
